import type {
  AnnouncementPost,
  EventPost,
  GiveawayPost,
  OtherPost,
  Post,
  SalePost,
} from "../types";

const isAnnouncementPost = (post: Post): post is AnnouncementPost =>
  (post as AnnouncementPost).postType === "ANNOUNCEMENT";

const isEventPost = (post: Post): post is EventPost =>
  (post as EventPost).postType === "EVENT";

const isGiveawayPost = (post: Post): post is GiveawayPost =>
  (post as GiveawayPost).postType === "GIVEAWAY";

const isOtherPost = (post: Post): post is OtherPost =>
  (post as OtherPost).postType === "OTHER";

const isSalePost = (post: Post): post is SalePost =>
  (post as SalePost).postType === "SALE";

export {
  isAnnouncementPost,
  isEventPost,
  isGiveawayPost,
  isOtherPost,
  isSalePost,
};
